import { defineMessages } from 'react-intl-next';

export const messages: {
    "atlassian-web-crawler": {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	['atlassian-web-crawler']: {
		id: 'search-page.products.custom-website',
		defaultMessage: 'Web page',
		description: 'display name for Web page',
	},
});
